import * as z from "zod/v4";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
// TEXT MESSAGE
export const TextMessageSchema = BaseMessageDbParser.extend({
  contentType: z.literal(ContentType.TEXT),
  structuredContent: z
    .union([z.string(), z.record(z.string(), z.any()), z.object({})])
    .optional(),
});

export type NewTextMessage = z.infer<typeof TextMessageSchema>;

export const TextMessageDbParser = TextMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type TextMessage = z.infer<typeof TextMessageDbParser>;
